import { NgModule } from '@angular/core';
import { ValidatorDirective } from './validator.directive';
import { RegisterDropDownValidatorDirective } from './register-validator-dropdown.directive';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorService } from './validator.service';
import { DropdownModule } from 'primeng/dropdown';
import { MuCheckHourDirective } from './mu-check-hour.directive';
import { RegisterAutoCompleteValidatorDirective } from './register-validator-autocomplete.directive';

@NgModule({
  imports: [TranslateModule.forChild({}), DropdownModule],
  declarations: [ValidatorDirective, RegisterDropDownValidatorDirective, RegisterAutoCompleteValidatorDirective, MuCheckHourDirective],
  exports: [ValidatorDirective, RegisterDropDownValidatorDirective, RegisterAutoCompleteValidatorDirective, MuCheckHourDirective],
  providers: [ValidatorService],
})
export class ValidatorModule {}
